/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ClientWorkspaceInviteLogControlllerAcceptInvite$Params {

/**
 * 초대 ID
 */
  id: string;
}

export function clientWorkspaceInviteLogControlllerAcceptInvite(http: HttpClient, rootUrl: string, params: ClientWorkspaceInviteLogControlllerAcceptInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceInviteLogControlllerAcceptInvite.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

clientWorkspaceInviteLogControlllerAcceptInvite.PATH = '/api/clientWorkspaceInviteLog/invite/{id}/accept';
